export const CATEGORIES = [
  {
    tag: "uitje",
    name: "Uitje"
  },
  {
    tag: "sport",
    name: "Sport"
  },
  {
    tag: "feest",
    name: "Feest"
  },
  {
    tag: "vakantie",
    name: "Vakantie"
  },
  {
    tag: "eten",
    name: "Eten"
  },
  {
    tag: "overig",
    name: "Overig"
  }
];
